var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _g, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 262,
    height: 255,
    viewBox: "0 0 262 255",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145.804 194.297H105.323V248.967H145.804V194.297Z",
    fill: "#68A2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M228.841 54.1356H22.2861C9.97783 54.1356 0 64.1043 0 76.4012V195.207C0 207.504 9.97783 217.472 22.2861 217.472H228.841C241.149 217.472 251.127 207.504 251.127 195.207V76.4012C251.127 64.1043 241.149 54.1356 228.841 54.1356Z",
    fill: "#68A2FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M173.363 244.275H77.7632C76.9062 244.275 76.2114 244.969 76.2114 245.825V253.45C76.2114 254.306 76.9062 255 77.7632 255H173.363C174.22 255 174.915 254.306 174.915 253.45V245.825C174.915 244.969 174.22 244.275 173.363 244.275Z",
    fill: "#68A2FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M152.686 194.297H112.205V248.967H152.686V194.297Z",
    fill: "#A4C7FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M235.723 54.1356H29.1684C16.8601 54.1356 6.88232 64.1043 6.88232 76.4012V195.207C6.88232 207.504 16.8601 217.472 29.1684 217.472H235.723C248.031 217.472 258.009 207.504 258.009 195.207V76.4012C258.009 64.1043 248.031 54.1356 235.723 54.1356Z",
    fill: "#A4C7FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M249.653 195.206V76.4014C249.653 68.7148 243.416 62.4837 235.722 62.4837L29.1686 62.4837C21.475 62.4837 15.238 68.7148 15.238 76.4014V195.206C15.238 202.893 21.475 209.124 29.1686 209.124H235.722C243.416 209.124 249.653 202.893 249.653 195.206Z",
    fill: "#68A2FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M248.063 76.4004V195.207C248.063 200.296 244.965 204.673 240.55 206.559C239.065 207.186 237.435 207.539 235.721 207.539H29.1668C27.4579 207.539 25.8277 207.192 24.3431 206.559C19.9282 204.678 16.8242 200.301 16.8242 195.207V76.4004C16.8242 71.3066 19.928 66.9295 24.3431 65.0486C25.8277 64.4161 27.4581 64.0691 29.1668 64.0691H235.72C237.435 64.0691 239.065 64.4218 240.55 65.0486C244.965 66.935 248.063 71.3121 248.063 76.4004H248.063Z",
    fill: "#E5F0F8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M180.246 244.275H84.6454C83.7883 244.275 83.0936 244.969 83.0936 245.825V253.45C83.0936 254.306 83.7883 255 84.6454 255H180.246C181.103 255 181.797 254.306 181.797 253.45V245.825C181.797 244.969 181.103 244.275 180.246 244.275Z",
    fill: "#A4C7FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M240.55 0V206.559C239.065 207.186 237.435 207.539 235.721 207.539H29.1669C27.4579 207.539 25.8277 207.192 24.3431 206.559V0H240.55Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M96.668 42.1161H37.1966V112.552H96.668V42.1161Z",
    fill: "#A4C7FF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M96.668 11.9169H37.1966V13.9416H96.668V11.9169Z",
    fill: "#E5F0F8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M96.668 16.079H37.1966V18.1038H96.668V16.079Z",
    fill: "#E5F0F8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M96.668 20.2412H37.1966V22.2659H96.668V20.2412Z",
    fill: "#E5F0F8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2062 24.4034H37.1966V26.4281H72.2062V24.4034Z",
    fill: "#E5F0F8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18_1264",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 42,
    width: 60,
    height: 71
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M96.668 42.1161H37.1966V112.552H96.668V42.1161Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18_1264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.5806 90.6273L86.6859 97.4226L84.6032 158.724L41.6656 159.389L35.1584 96.3295L56.1296 89.5066L71.5806 90.6273Z",
    fill: "#E5F0F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5765 81.7738V91.3474C71.5765 91.3474 71.0038 93.4146 66.1324 93.4346C61.271 93.4446 56.1284 90.2233 56.1284 90.2233L57.6351 69.2901L71.5765 81.7738Z",
    fill: "#FDAE97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5806 90.0341L61.629 79.7124L71.5806 79.5819V90.0341Z",
    fill: "#E89780"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.655 62.5166V75.9937C75.655 78.7132 74.8916 82.7474 71.8281 83.6806C68.7746 84.6138 64.5661 83.3393 61.6333 80.1584C58.7002 76.9672 52.1915 62.5969 61.2414 57.2886C70.3014 51.98 75.4442 61.1119 75.6552 62.5168L75.655 62.5166Z",
    fill: "#FDAE97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.714 148.111C97.8046 150.432 91.8866 148.318 89.5631 143.413L74.1156 110.805C71.7918 105.9 73.9077 99.9871 78.8173 97.6657C83.727 95.3442 89.645 97.458 91.9686 102.363L107.416 134.972C109.74 139.877 107.624 145.789 102.714 148.111Z",
    fill: "#68A2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1806 56.7903C62.1806 56.7903 73.1315 51.7431 75.6568 55.0581C78.1821 58.373 73.9749 59.5304 73.9749 59.5304C73.9749 59.5304 79.1978 58.9142 78.9948 62.4321C78.7916 65.9501 65.7228 61.1468 65.7228 61.1468C65.7228 61.1468 70.0564 63.1087 67.5511 64.6648C65.0456 66.2208 62.1806 64.1912 62.1806 64.1912C62.1806 64.1912 59.6959 65.6107 60.1024 72.1301C60.509 78.6495 56.614 80.0894 56.614 80.0894C56.614 80.0894 57.0805 70.2121 55.1718 67.5737C53.263 64.9353 56.0653 55.14 62.1806 56.7903Z",
    fill: "#322A28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7163 73.6415C61.779 75.3042 62.0628 76.4743 60.7563 77.308C59.4498 78.1415 57.2771 77.8783 56.2145 76.2156C55.1518 74.553 55.3495 72.5294 56.6562 71.6959C57.9629 70.8624 59.6537 71.979 60.7165 73.6417L60.7163 73.6415Z",
    fill: "#FDAE97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3055 73.514C57.3055 73.514 58.6479 73.3139 59.5667 75.0322C59.5667 75.0322 58.7187 74.8377 57.6875 75.0322",
    stroke: "#E89780",
    strokeWidth: 1.227,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5178 70.1534C67.5178 70.7843 67.849 71.2954 68.2573 71.2954C68.6656 71.2954 68.9969 70.7841 68.9969 70.1534C68.9969 69.5227 68.6658 69.0111 68.2573 69.0111C67.8488 69.0111 67.5178 69.5225 67.5178 70.1534Z",
    fill: "#2C3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9924 77.3177C67.9924 77.3177 69.091 79.4548 71.8695 78.9536",
    stroke: "#2C3447",
    strokeWidth: 1.537,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6587 70.5899L72.0523 74.618C72.1935 75.0262 72.0383 75.4778 71.6759 75.7133L70.5403 76.4516",
    stroke: "#2C3447",
    strokeWidth: 1.537,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3529 68.2573C66.3529 68.2573 67.9104 67.1689 69.3951 67.859",
    stroke: "#2C3447",
    strokeWidth: 1.537,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.155 70.1534C75.155 70.7843 74.8237 71.2954 74.4154 71.2954C74.0071 71.2954 73.6759 70.7841 73.6759 70.1534C73.6759 69.5227 74.0069 69.0111 74.4154 69.0111C74.8239 69.0111 75.155 69.5225 75.155 70.1534Z",
    fill: "#2C3447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8413 68.1948C75.8413 68.1948 74.7621 67.1689 73.2776 67.8592",
    stroke: "#2C3447",
    strokeWidth: 1.537,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6933 74.3187C68.4989 74.8982 67.4066 75.0552 66.2531 74.6692C65.0997 74.2832 64.3221 73.5004 64.5165 72.9211C64.7108 72.3417 65.8032 72.1846 66.9567 72.5706C68.11 72.9566 68.8876 73.7391 68.6933 74.3187Z",
    fill: "#E89780"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.655 72.5515V74.7895C74.711 74.8998 73.9375 74.639 73.8067 74.1472C73.6663 73.5651 74.4897 72.8527 75.655 72.5515Z",
    fill: "#E89780"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7961 95.1359H65.3002L64.994 95.7987L66.6049 96.9968H67.9796L69.1279 95.5948L68.7961 95.1359Z",
    fill: "#F74242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1879 89.3967L67.1758 93.4344L65.1727 98.0167L55.7033 90.4034L56.1879 89.3967Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5765 90.5086L72.1038 91.5827L69.2553 97.5832L67.1758 93.4344L71.5765 90.5086Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9796 96.9968L73.1852 137.364L69.1279 142.59L63.8525 137.85L66.6049 96.9968H67.9796Z",
    fill: "#F74242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1713 91.3607C73.1713 91.3607 74.2048 102.156 75.8778 118.459C77.5508 134.761 77.6134 161.801 93.5759 162.961C93.5759 162.961 95.3162 159.904 100.985 160.958C100.985 160.958 96.0596 158.407 92.2949 152.562C88.5301 146.718 86.6857 97.4226 86.6857 97.4226L73.1713 91.3607Z",
    fill: "#68A2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0638 100.481L75.3399 113.192L71.2831 109.738L71.5765 100.73L74.0638 100.481Z",
    fill: "#E5F0F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3911 90.7229C52.3911 90.7229 56.4489 108.206 58.4361 124.418C60.4233 140.63 59.7492 156.308 64.8623 165.827C64.8623 165.827 44.3537 169.513 44.4012 177.778C44.4012 177.778 38.6198 171.408 38.5698 162.682C38.5198 153.957 35.1586 96.3293 35.1586 96.3293L52.3913 90.7227L52.3911 90.7229Z",
    fill: "#68A2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6631 151.628C35.2394 151.921 30.5616 147.727 30.268 142.309L28.3163 106.285C28.0227 100.866 32.2201 96.1927 37.644 95.8994C43.0678 95.6061 47.7455 99.7996 48.039 105.218L49.9907 141.242C50.2843 146.661 46.0869 151.334 40.6631 151.628Z",
    fill: "#68A2FF"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M129.782 42.1161H104.003V45.6734H129.782V42.1161Z",
    fill: "#A4C7FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M165.246 42.1161H137.758V45.6734H165.246V42.1161Z",
    fill: "#E5F0F8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M201.351 53.2626H137.758V56.8199H201.351V53.2626Z",
    fill: "#E5F0F8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M188.426 42.1161H169.59V45.6734H188.426V42.1161Z",
    fill: "#E5F0F8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M227.695 42.1161H192.592V45.6734H227.695V42.1161Z",
    fill: "#E5F0F8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M129.782 53.2626H104.003V56.8199H129.782V53.2626Z",
    fill: "#A4C7FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M168.985 64.4091H137.758V67.9664H168.985V64.4091Z",
    fill: "#E5F0F8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M129.782 64.4091H104.003V67.9664H129.782V64.4091Z",
    fill: "#A4C7FF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M227.695 75.5553H137.758V79.1127H227.695V75.5553Z",
    fill: "#E5F0F8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M129.782 75.5553H104.003V79.1127H129.782V75.5553Z",
    fill: "#A4C7FF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M153.371 86.7018H137.758V90.2592H153.371V86.7018Z",
    fill: "#E5F0F8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M129.782 86.7018H104.003V90.2592H129.782V86.7018Z",
    fill: "#A4C7FF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M149.971 97.8483H137.758V101.406H149.971V97.8483Z",
    fill: "#E5F0F8"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M165.246 97.8483H153.033V101.406H165.246V97.8483Z",
    fill: "#E5F0F8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M180.521 97.8483H168.308V101.406H180.521V97.8483Z",
    fill: "#E5F0F8"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M195.797 97.8483H183.584V101.406H195.797V97.8483Z",
    fill: "#E5F0F8"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M129.782 97.8483H104.003V101.406H129.782V97.8483Z",
    fill: "#A4C7FF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M191.168 108.995H137.758V112.552H191.168V108.995Z",
    fill: "#E5F0F8"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M129.782 108.995H104.003V112.552H129.782V108.995Z",
    fill: "#A4C7FF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M227.695 120.805H37.1966V124.505H227.695V120.805Z",
    fill: "#E5F0F8"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M227.695 129.628H37.1966V133.327H227.695V129.628Z",
    fill: "#E5F0F8"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M227.695 138.45H37.1966V142.15H227.695V138.45Z",
    fill: "#E5F0F8"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M227.695 147.272H37.1966V150.972H227.695V147.272Z",
    fill: "#E5F0F8"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M227.695 156.094H37.1966V159.794H227.695V156.094Z",
    fill: "#E5F0F8"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M227.695 164.917H37.1966V168.617H227.695V164.917Z",
    fill: "#E5F0F8"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M227.695 173.739H37.1966V177.439H227.695V173.739Z",
    fill: "#E5F0F8"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M227.695 182.561H37.1966V186.261H227.695V182.561Z",
    fill: "#E5F0F8"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M227.695 191.384H37.1966V195.083H227.695V191.384Z",
    fill: "#E5F0F8"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M227.695 200.206H37.1966V203.906H227.695V200.206Z",
    fill: "#E5F0F8"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M218.286 55.1312L231.522 54.9066L230.829 41.021L230.498 34.3809L230.479 34.0502L220.123 29.7003L219.785 34.3935L219.535 37.8132L218.286 55.1312Z",
    fill: "#FDAE97"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M244.172 98.1128L249.738 144.146C249.912 145.31 249.907 146.519 249.669 147.741C248.551 153.488 242.981 157.242 237.227 156.125C231.474 155.008 229.273 150.57 228.239 143.97C226.256 131.3 219.328 93.2883 219.328 93.2883L244.172 98.1128Z",
    fill: "#5092FF"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M208.081 95.7958L228.527 97.1663L228.425 119.797L225.998 123.383L223.749 145.2L203.052 143.547L208.081 95.7958Z",
    fill: "#5092FF"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M224.732 49.3242C219.876 49.4309 217.512 46.7692 217.003 45.5954L219.115 45.0256L231.01 44.6483L232.452 45.1097C231.843 46.2424 229.694 49.215 224.732 49.3242Z",
    fill: "#FDAE97"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M207.497 79.5126L207.706 99.3554H244.322L244.153 49.3294L231.323 44.6978C231.18 44.9612 231.024 45.2365 230.832 45.5237L230.784 45.5835C230.09 46.4691 228.76 47.3069 225.034 47.3907C221.932 47.4626 220.41 47.0318 219.548 46.4693L219.536 46.4573C219.069 46.1462 218.697 45.5317 218.482 45.1967L206.467 48.109L207.282 73.3613L207.497 79.5126Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M217.003 45.5954C217.003 45.5954 218.042 64.1083 217.893 74.8091C217.743 85.5098 217.003 112.552 217.003 112.552C217.003 112.552 210.22 112.696 203.981 111.433C203.981 111.433 203.887 99.1822 205.607 90.7333C207.327 82.2844 206.467 48.1084 206.467 48.1084L217.003 45.5954Z",
    fill: "#307CF8"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M239.956 49.6048L240.034 49.5744C243.456 48.2331 247.325 49.9205 248.668 53.3403L259.568 81.1047C260.91 84.5242 259.221 88.3892 255.799 89.7304L255.721 89.7608C252.298 91.102 248.43 89.4147 247.087 85.9952L236.187 58.2297C234.845 54.8106 236.534 50.9458 239.956 49.6048Z",
    fill: "#307CF8"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M253.614 190.87L234.382 190.857L228.584 146.143C227.979 140.316 232.207 135.098 238.032 134.485C243.864 133.88 249.079 138.104 249.693 143.923C249.748 144.429 249.754 144.923 249.736 145.424L253.084 184.67L253.613 190.87L253.614 190.87Z",
    fill: "#5092FF"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M223.822 144.396L218.884 190.87H199.99L203.019 144.142C202.994 143.649 203.134 143.099 203.175 142.59C203.693 136.754 208.335 132.395 214.177 132.904C220.01 133.421 224.332 138.56 223.822 144.396Z",
    fill: "#5092FF"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M219.487 25.2022C219.487 25.2022 218.78 20.5269 220.787 21.4115C222.795 22.2961 219.487 25.2022 219.487 25.2022Z",
    fill: "#322A28"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M232.453 45.1097C232.453 45.1097 227.445 71.0442 227.277 83.9343L227.109 96.8244L227.682 112.552C227.682 112.552 241.632 114.28 246.51 112.293C246.51 112.293 246.85 93.6229 245.554 87.0126C244.258 80.4023 244.153 49.3293 244.153 49.3293L232.453 45.1097Z",
    fill: "#307CF8"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M219.17 42.8739L226.611 37.4539L219.535 37.8132L219.17 42.8739Z",
    fill: "#EA9D85"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M229.88 108.745C229.88 108.745 240.035 110.425 244.765 108.745",
    stroke: "white",
    strokeWidth: 1.807,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M220.424 21.8768C220.424 21.8768 219 26.087 217.989 29.0735L217.155 31.5421C216.495 33.4924 216.064 36.5704 218.035 37.9813C219.998 39.3899 223.325 39.4949 226.2 37.9235C229.078 36.3451 237.231 27.615 232.029 21.617C226.819 15.6162 220.915 20.9203 220.424 21.8768Z",
    fill: "#FDAE97"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M214.589 50.7066C214.589 50.7066 215.597 66.8907 215.953 74.052C216.309 81.2132 214.589 106.421 214.589 106.421",
    stroke: "white",
    strokeWidth: 1.807,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M230.732 39.0701C230.732 39.0701 228.71 36.2501 229.171 34.7896C229.631 33.3292 228.32 31.2558 229.132 29.0375C229.945 26.8192 230.282 25.8832 229.073 25.7151C227.864 25.547 219.062 25.4504 219.773 21.4413C220.485 17.4321 231.265 15.9342 233.672 23.5767C233.672 23.5767 236.351 24.0783 234.219 29.5017C232.088 34.925 231.714 35.3118 230.732 39.0701Z",
    fill: "#322A28"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M234.594 47.6511C234.594 47.6511 232.686 63.5011 231.522 71.3307C230.358 79.1603 230.157 98.4589 229.88 105.609",
    stroke: "white",
    strokeWidth: 1.807,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M228.439 33.4722C227.273 34.4074 226.786 35.1778 227.521 36.092C228.256 37.0062 229.877 37.3432 231.043 36.4082C232.208 35.473 232.557 33.974 231.822 33.06C231.088 32.1457 229.604 32.5372 228.439 33.4724L228.439 33.4722Z",
    fill: "#FDAE97"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M224.407 29.3239C224.254 29.7764 223.892 30.063 223.6 29.9641C223.307 29.8651 223.193 29.4182 223.346 28.9658C223.499 28.5134 223.861 28.2267 224.154 28.3257C224.447 28.4246 224.56 28.8715 224.407 29.3239Z",
    fill: "#322A28"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M218.93 27.4749C218.777 27.9274 218.89 28.3743 219.183 28.4732C219.476 28.5722 219.838 28.2855 219.991 27.8331C220.144 27.3807 220.03 26.9338 219.737 26.8348C219.444 26.7359 219.083 27.0225 218.93 27.4749Z",
    fill: "#322A28"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M222.554 32.0266C222.552 32.4892 223.298 32.8664 224.219 32.8689C225.139 32.8715 225.887 32.4984 225.888 32.0356C225.889 31.573 225.144 31.1959 224.223 31.1933C223.302 31.1908 222.555 31.564 222.554 32.0266Z",
    fill: "#EA9D85"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M217.99 29.0738L217.447 30.6786C218.097 30.9864 218.715 30.9864 218.928 30.6655C219.17 30.2821 218.752 29.5716 217.99 29.0738Z",
    fill: "#EA9D85"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M230.273 35.2029C229.581 34.8137 228.926 34.7479 228.926 34.7479C230.002 33.7381 230.916 34.2065 230.916 34.2065",
    stroke: "#EA9D85",
    strokeWidth: 1.761,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M222.049 28.8766L220.072 31.4281C219.872 31.6865 219.874 32.048 220.076 32.3046L220.39 32.702L220.712 33.1091",
    stroke: "#332B27",
    strokeWidth: 1.126,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M225.384 28.6282C225.384 28.6282 224.739 27.3435 223.501 27.2698",
    stroke: "#332B27",
    strokeWidth: 1.126,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M218.913 25.904C218.913 25.904 219.935 25.4296 220.833 26.2839",
    stroke: "#332B27",
    strokeWidth: 1.126,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M216.157 198.133L216.664 190.87H202.508L201.955 198.133H216.157Z",
    fill: "#FDAE97"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M198.198 89.747L198.118 89.7251C194.584 88.7578 192.485 85.078 193.453 81.5479L201.342 52.7839C202.31 49.2536 205.993 47.1568 209.526 48.1239L209.607 48.1458C213.14 49.1131 215.239 52.7927 214.271 56.323L206.383 85.087C205.414 88.6173 201.731 90.7141 198.198 89.747Z",
    fill: "#307CF8"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M202.258 194.16L216.664 190.87H202.508L202.258 194.16Z",
    fill: "#EA9D85"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M237.169 198.133L236.626 190.858L251.126 190.87L251.372 198.133H237.169Z",
    fill: "#FDAE97"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M236.929 194.916L251.126 190.87L236.626 190.858L236.929 194.916Z",
    fill: "#EA9D85"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M194.979 204.242H215.882L215.918 203.393L216.175 197.764H201.951C200.19 197.764 198.561 198.797 197.315 199.874C196.285 200.795 195.518 202.004 195.159 203.392C195.075 203.668 195.015 203.955 194.979 204.242Z",
    fill: "#322A28"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M194.979 204.242H215.882L215.918 203.393H195.159C195.075 203.668 195.015 203.955 194.979 204.242Z",
    fill: "#FFF1F0"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M201.523 198.922C201.523 198.922 203.33 195.754 204.546 197.006C205.763 198.259 201.523 198.922 201.523 198.922Z",
    stroke: "#FFF1F0",
    strokeWidth: 1.395,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M202.159 199.553L201.523 198.922M201.523 198.922C201.523 198.922 199.716 195.754 198.499 197.006C197.282 198.259 201.523 198.922 201.523 198.922Z",
    stroke: "#FFF1F0",
    strokeWidth: 1.395,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M201.037 199.553L201.523 198.922",
    stroke: "#FFF1F0",
    strokeWidth: 1.395,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M258.239 204.242H237.336L237.3 203.393L237.043 197.764H251.267C253.028 197.764 254.658 198.797 255.903 199.874C256.933 200.795 257.7 202.004 258.06 203.392C258.143 203.668 258.203 203.955 258.239 204.242Z",
    fill: "#322A28"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M258.239 204.242H237.336L237.3 203.393H258.06C258.143 203.668 258.203 203.955 258.239 204.242Z",
    fill: "#FFF1F0"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M251.696 199.114C251.696 199.114 249.889 195.946 248.672 197.198C247.455 198.451 251.696 199.114 251.696 199.114Z",
    stroke: "#FFF1F0",
    strokeWidth: 1.395,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M251.059 199.745L251.695 199.114M251.695 199.114C251.695 199.114 253.502 195.946 254.719 197.198C255.936 198.451 251.695 199.114 251.695 199.114Z",
    stroke: "#FFF1F0",
    strokeWidth: 1.395,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M252.181 199.745L251.696 199.114",
    stroke: "#FFF1F0",
    strokeWidth: 1.395,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M225.528 127.942L223.863 122.387H222.268L219.727 115.512",
    stroke: "white",
    strokeWidth: 0.916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M251.696 185.621H235.329",
    stroke: "white",
    strokeWidth: 0.916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M218.322 185.621H201.955",
    stroke: "white",
    strokeWidth: 0.916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M222.032 34.2904L219.383 34.5749C219.383 34.5749 219.591 35.9407 220.912 35.8733C222.232 35.8059 222.032 34.2904 222.032 34.2904Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M204.841 107.805C204.841 107.805 209.715 109.428 214.589 108.139",
    stroke: "white",
    strokeWidth: 1.807,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M214.589 79.972C214.589 80.473 214.183 80.8792 213.681 80.8792C213.18 80.8792 212.773 80.473 212.773 79.972C212.773 79.471 213.18 79.0649 213.681 79.0649C214.183 79.0649 214.589 79.471 214.589 79.972Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M214.589 88.3048C214.589 88.8058 214.183 89.2119 213.681 89.2119C213.18 89.2119 212.773 88.8058 212.773 88.3048C212.773 87.8038 213.18 87.3976 213.681 87.3976C214.183 87.3976 214.589 87.8038 214.589 88.3048Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M213.442 102.587C213.442 103.088 213.036 103.494 212.534 103.494C212.033 103.494 211.626 103.088 211.626 102.587C211.626 102.086 212.033 101.68 212.534 101.68C213.036 101.68 213.442 102.086 213.442 102.587Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M188.602 97.6305H219.837L211.685 74.2624H180.45L188.602 97.6305Z",
    fill: "#A5BBD6"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M219.496 96.496L229.71 87.4701H199.499L188.261 96.496H219.496Z",
    fill: "#89A5C7"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M189.192 97.1134H220.427L212.275 73.7454H181.04L189.192 97.1134Z",
    fill: "#A5BBD6"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M181.04 73.7454L180.45 74.2624H211.685L219.837 97.6305L220.427 97.1134L212.275 73.7454H181.04Z",
    fill: "#89A5C7"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M229.71 87.4701L230.05 88.6045L219.837 97.6305L219.441 96.496L229.71 87.4701Z",
    fill: "#586773"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M198.826 87.7436C200.739 87.7436 202.289 87.058 202.289 86.2122C202.289 85.3665 200.739 84.6808 198.826 84.6808C196.914 84.6808 195.363 85.3665 195.363 86.2122C195.363 87.058 196.914 87.7436 198.826 87.7436Z",
    fill: "#89A5C7"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M213.608 100.886C213.813 101.437 217.377 101.408 219.842 100.576C221.932 99.8727 226.575 97.7337 227.939 97.0938L225.361 88.7242C224.489 88.8747 222.677 89.0087 221.856 89.2019C219.669 89.7162 215.486 91.5039 215.604 92.3196C215.715 93.1284 219.537 92.3621 219.306 92.743C219.075 93.1239 216.27 94.6331 214.998 94.7415C213.72 94.8573 210.95 94.6539 210.561 95.2891C210.164 95.9319 210.931 96.7251 210.931 96.7251C210.931 96.7251 209.88 96.5252 209.875 97.2033C209.871 97.8816 211.428 98.6011 211.428 98.6011C211.428 98.6011 210.862 98.424 211.041 99.1711C211.229 99.925 213.908 100.199 213.908 100.199C213.908 100.199 213.389 100.336 213.608 100.886Z",
    fill: "#FDAE97"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M224.852 87.0706L251.194 76.4952C254.361 75.3328 258.034 77.3066 259.363 80.8915C260.684 84.4765 259.173 88.3675 256.007 89.5382L228.562 99.115L224.852 87.0706H224.852Z",
    fill: "#307CF8"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M227.652 85.9465L244.494 79.3895L239.476 66.6072",
    stroke: "#332B27",
    strokeWidth: 1.581,
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M245.696 93.136L230.961 98.2778",
    stroke: "#332B27",
    strokeWidth: 1.581,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1);
export default __webpack_public_path__ + "static/media/Group 1.8c67e22b7851d3f7a161d76bb8c9fead.svg";
export { ForwardRef as ReactComponent };